import React from 'react';
import '../../styles/roboticsProduct.css'
import AnimatedArrowButton from '../AnimatedArrowButton';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import product1 from '../../assets/v1.png';
import product2 from '../../assets/v2.png';
import product3 from '../../assets/v3.png';
import product4 from '../../assets/v4.png';
import bgimage from '../../assets/half-circle.png';

const Values= () => {

    const sliderSettings = {
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        arrows:false,
        pauseOnHover: true,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
            },
          },
        ],
      };

    const cards = [
        { no:'01', name: 'Quality', company: "Commitment to providing the highest-quality products." , image:product1  },
        { no:'02',name: 'Integrity', company: "Fostering honest and transparent relationships." , image:product3  },
        { no:'03',name: 'Innovation', company: "Continuously seeking improved solutions" , image:product2 },
        { no:'04',name: 'Customer Focus', company: "Prioritizing client satisfaction and partnerships" , image:product4 }, 
        
      ];

    return(<div id='horecafeaturedproducts' className='roboticsproduct mt-5 pb-5 ' style={{height:'auto'}}>

        
            <div className='roboticsproduct-inner pt-4' >
            
            <h4 className='mx-3' style={{color:'#FFD52B',textAlign:'left'}}>Values</h4>
            <hr></hr>
            
            <div className='myservices' style={{display:'flex',padding:'25px',gap:'10px',paddingTop:"2rem", width:'100%'}}>
                        
                        <div className='services-msg' style={{textAlign:'left', width:'100%'}}>
                            <div style={{display:'flex' , alignItems:'start', justifyContent:'space-between', width:'100%'}}><h1 style={{fontWeight:"600"}}>Our Core Values</h1> <div className='button1'> </div> </div>
                            <div className='button2'></div> 
                        </div>
            </div>
            
            <div style={{  maxWidth: "90%", margin: "auto" }}>
      <Slider {...sliderSettings}>
        {cards.map((card) => (
          <div key={card.id} style={{ padding: "10px"}}>
            <div
              style={{
                
                backgroundColor: "#0C0A00",
                border:'1px solid #383838',
                display: "flex",
                alignItems: "center",
                padding:'1rem',
                justifyContent: "start",
                borderRadius: "10px",
                marginLeft:"10px",
                marginRight:"10px",
                overflow:'hidden',
                
                flexDirection:'column',
                textAlign:'left'
              }}
              className='product-card'
            >
              <div style={{width:'100%', overflow:'hidden'}}>
                <h1 style={{textAlign:'right',fontWeight:'600'}}>{card.no}</h1>
                <img src={card.image} style={{objectFit:'cover',width:'50px', height:'50px',textAlign:'left'}}></img>
                

              </div>
              <div style={{ height:'130px'}}>
              <h5 style={{width:'100%',marginTop:'1rem'}}>{card.name}</h5>
            <p style={{width:'100%', fontSize:'0.9rem', color:'white',paddingBottom:'0.9rem',marginBottom:'0.3rem'}}>{card.company}</p>
            </div>
            </div>
            
          </div>
        ))}
      </Slider>
    </div>
            

            </div>
        
    

    </div>);

}

export default Values;